<template lang="html">
  <div class="cw-invoices">
    <section class="section has-text-centered is-bottom-paddingless">
      <cw-segment-control
        v-if="displayPaymentInfo"
        class="types-control"
        :segments="['Unpaid', 'Paid']"
        :selected="typeSelected"
        @update:selected="updateType"
      ></cw-segment-control>

      <div class="field">
        <div class="control has-icons-left">
          <input
            class="input is-underlined is-medium"
            type="text"
            placeholder="Search Box or Lot"
            v-model="searchQuery"
          />
          <span class="icon is-left">
            <i class="las la-2x la-search"></i>
          </span>
        </div>
      </div>
      <p
        class="title is-size-5 font-light has-text-grey-light has-text-centered"
        v-if="invoices.length != 0 || loading"
      >
        {{ filteredInvoices.length }} Invoices
      </p>
    </section>
    <section class="section">
      <div class="has-text-centered">
        <span v-if="loading" class="icon has-text-primary is-large">
          <i class="las la-2x la-sync fa-spin"></i>
        </span>
      </div>
      <cw-invoice-list
        :invoices="filteredInvoices"
        :displayPaymentInfo="displayPaymentInfo"
        :selectionHandler="invoiceSelected"
      ></cw-invoice-list>
      <p
        class="help has-text-grey-light is-padded-small has-text-centered"
        v-if="
          displayInvoiceType === 'Paid' &&
            searchQuery === '' &&
            (invoices.length != 0 || loading)
        "
      >
        Please contact us for older invoices.
      </p>
    </section>

    <section class="section">
      <div class="has-text-centered">
        <div v-if="error" class="centerit">
          <div class="wifi-loader is-primary"></div>
        </div>
        <div class="title is-size-5 font-light has-text-grey-light">
          <p v-if="error" class="is-padded-medium">
            There has been a network error!
          </p>
          <p
            v-else-if="
              !loading && (!filteredInvoices || filteredInvoices.length === 0)
            "
          >
            No Invoices found
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { INVOICES } from '@/graphql/constants';
import authRequired from '@/components/mixins/auth-required';
import permissionsRequired from '@/components/mixins/permissions-required';
import autoRefresh from '@/components/mixins/auto-refresh';
import { mapState } from 'vuex';

export default {
  name: 'cw-invoices',
  // share common functionality with component mixins
  mixins: [authRequired, autoRefresh, permissionsRequired],
  props: {},
  // variables
  data() {
    return {
      error: undefined,
      loadingInvoices: 0,
      invoices: [],
      searchQuery: '',
    };
  },
  apollo: {
    invoices: {
      query: INVOICES,
      variables() {
        return {
          customerId: this.$store.state.locations.selectedCustomerId,
        };
      },
      result() {
        this.error = null;
      },
      error(err) {
        this.error = err;
      },
      update: data => data.invoices,
      loadingKey: 'loadingInvoices',
    },
  },
  computed: {
    loading() {
      return this.loadingInvoices + this.loadingCustomer > 0;
    },
    filteredInvoices() {
      let invoices = this.invoices.filter(invoice => {
        if (this.displayPaymentInfo) {
          switch (this.displayInvoiceType) {
            case 'Unpaid':
              return invoice.balance !== 0;
            case 'Paid':
              return invoice.balance === 0;
            default:
              return false;
          }
        } else {
          return true;
        }
      });
      let query = this.searchQuery.toLowerCase();

      if (query.length > 0) {
        invoices = invoices.filter(invoice => {
          let matchId =
            invoice.id && `${invoice.id}`.toLowerCase().indexOf(query) > -1;

          let matchProject =
            invoice.projectName &&
            invoice.projectName.toLowerCase().indexOf(query) > -1;

          let matchLot =
            invoice.subProjectName &&
            invoice.subProjectName
              .toLowerCase()
              .indexOf(query.replace('lot', '').trim()) > -1;

          let matchDescription =
            invoice.description &&
            invoice.description.toLowerCase().indexOf(query) > -1;

          return matchProject || matchId || matchLot || matchDescription;
        });
      }
      return invoices;
    },
    typeSelected() {
      switch (this.displayInvoiceType) {
        case 'Unpaid':
          return [0];
        case 'Paid':
          return [1];
        default:
          return [0];
      }
    },
    ...mapState('invoices', {
      displayInvoiceType: state => state.displayInvoiceType,
    }),
    displayPaymentInfo() {
      return this.canViewInvoicesPaymentStatus;
    },
  },
  // methods
  watch: {
    userInfo() {
      this.$apollo.queries.invoices.refetch();
    },
    '$store.state.locations.selectedCustomerId'() {
      this.$apollo.queries.invoices.refetch();
    },
  },
  methods: {
    invoiceSelected(invoice) {
      console.log(`invoice selected ${invoice.id}`);
      // this.$router.push({ path: `/invoices/${invoice.id}` });
    },
    updateType(t) {
      let display = 'Unpaid';
      switch (t) {
        case 0:
          display = 'Unpaid';
          break;
        case 1:
          display = 'Paid';
          break;
        default:
          display = 'Unpaid';
      }
      this.$store.commit('invoices/setDisplayInvoiceType', { display });
    },
  },
};
</script>

<style lang="stylus" scoped>
.types-control {
  margin-bottom: 1.5em
}
</style>
